var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { validateDataArray, validateNumberClasses } from "../utils";
export var jenksBuckets = function (data, numberClasses) { return __awaiter(void 0, void 0, void 0, function () {
    var mat1, mat2, v, y, yl, t, tl, l, ll, s1, s2, w, m, ml, i3, val, i4, p, pl, k, buckets, countNum, id, idxVal;
    return __generator(this, function (_a) {
        validateDataArray(data.length);
        validateNumberClasses(numberClasses, data.length);
        data.sort(function (a, b) { return a - b; });
        mat1 = Array.from(Array(data.length + 1)).map(function (el) { return el = Array(numberClasses + 1); });
        mat2 = Array.from(Array(data.length + 1)).map(function (el) { return el = Array(numberClasses + 1); });
        v = 0.0;
        for (y = 1, yl = numberClasses + 1; y < yl; y++) {
            mat1[0][y] = 1;
            mat2[0][y] = 0;
            for (t = 1, tl = data.length + 1; t < tl; t++) {
                mat2[t][y] = Infinity;
            }
            v = 0.0;
        }
        for (l = 2, ll = data.length + 1; l < ll; l++) {
            s1 = 0.0;
            s2 = 0.0;
            w = 0.0;
            for (m = 1, ml = l + 1; m < ml; m++) {
                i3 = l - m + 1;
                val = data[i3 - 1];
                s2 += val * val;
                s1 += val;
                w += 1;
                v = s2 - (s1 * s1) / w;
                i4 = i3 - 1;
                if (i4 != 0) {
                    for (p = 2, pl = numberClasses + 1; p < pl; p++) {
                        if (mat2[l][p] >= (v + mat2[i4][p - 1])) {
                            mat1[l][p] = i3;
                            mat2[l][p] = v + mat2[i4][p - 1];
                        }
                    }
                }
            }
            mat1[l][1] = 1;
            mat2[l][1] = v;
        }
        k = data.length;
        buckets = Array.from(Array(numberClasses + 1)).fill(0);
        buckets[numberClasses] = data[data.length - 1];
        buckets[0] = data[0];
        countNum = numberClasses;
        while (countNum >= 2) {
            id = mat1[k][countNum] - 2;
            buckets[countNum - 1] = data[id];
            idxVal = mat1[k][countNum];
            k = idxVal - 1;
            countNum -= 1;
        }
        if (buckets[0] == buckets[1]) {
            buckets[0] = 0;
        }
        return [2 /*return*/, buckets];
    });
}); };
